import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const cargoTypeApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
  string1: v.pipe(
    v.nullish(v.string()),
    v.transform((value) => value ?? undefined),
  ),
});

export const cargoTypeSchema = v.object({
  ...cargoTypeApiSchema.entries,
  ...optionSchema.entries,
  string1: v.optional(v.string()),
});

export const cargoTypesApiSchema = paginatedSchema(cargoTypeApiSchema);

export type CargoTypeApi = v.InferOutput<typeof cargoTypeApiSchema>;
export type CargoTypesApi = v.InferOutput<typeof cargoTypesApiSchema>;

export type CargoTypeFilters = Filters<CargoTypeApi>;

export type CargoTypeFiltersUpdateApi = FiltersUpdateApi<CargoTypeApi>;

export type CargoType = Prettify<Option<v.InferOutput<typeof cargoTypeSchema>>>;

export type CargoTypes = Entities<CargoType>;
